
import { FluidTextMorph } from "@/components/ui/fluid-text-morph";
import { WhatsAppIcon } from "@/components/icons/whatsapp-icon";
import { GlowButton } from "@/components/ui/glow-button";

// 1. --- DEMO-SPECIFIC DATA ---
// The content is defined here, not inside the component.
const WORD_PAIRS: [string, string][] = [
  ["Design", "FullStackDev"],
  ["Marketing", "Inovação"],
  ["MobileApp", "WebApp"],
  ["UX/UI", "SaaS"],
];

function App() {
  // 2. --- DEMO-SPECIFIC LAYOUT & STYLING ---
  // The background and centering are part of the demo, not the component.
  // It uses theme variables (`bg-background`) to be theme-aware.
  return (
    <div className="flex min-h-screen w-[85%] mx-auto flex-col items-center justify-start bg-background">
      <img
        src="/images/logotype.webp"
        alt="Logo"
        className="mt-12 w-64 object-contain"
      />
      {/* The instruction text is also part of the demo page. */}
      <p className="mt-2 mb-8 text-xs text-muted-foreground">
        Em breve, mais uma aplicação Omnimaker pra você!
      </p>
      {/* 3. --- RENDERING THE REUSABLE COMPONENT ---
          The component is now used by passing props to it. */}
      <FluidTextMorph wordPairs={WORD_PAIRS} className="my-12"/>
      
      <h1 className="max-w-md text-xl my-2 text-center text-muted-foreground">
        O aplicativo <strong>{import.meta.env.VITE_APP_NAME || "Omnimaker Demo App"}</strong> está em desenvolvimento, mas você pode fazer seu pedido pelo <strong>WhatsApp</strong>.
      </h1>
      <GlowButton
        href={`https://wa.me/${import.meta.env.VITE_WHATSAPP_NUMBER || "5575981785769"}`}
        target="_blank"
        rel="noopener noreferrer"
        className="my-12"
        icon={<WhatsAppIcon className="h-5 w-5 fill-current my-2" />}
      >
        Peça pelo WhatsApp
      </GlowButton>

      <p className="my-8 text-muted-foreground">
        Desenvolvido por <a target="_blank" rel="noopener noreferrer" href="https://omnimaker.com.br" className="text-primary">Omnimaker</a>
      </p>

      
    </div>
  );
}

export default App;
